import Complain from './Complain.jsx';
import ListComplains from './ListComplains.jsx';
import ComplainDetail from './ComplainDetail.jsx';

export {Complain, ListComplains, ComplainDetail}



// WEBPACK FOOTER //
// ./components/complains/index.js